import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import lensesImage from '../../../assets/images/contact-lens.png';
import glassesImage from '../../../assets/images/eye-glasses.png';
import shadesImage from '../../../assets/images/shades.png';

const productsData = {
  glasses: [
    { id: 1, brand: 'OAKLEY', title: 'Executive Pro', price: '189', image: 'https://images.unsplash.com/photo-1572635196237-14b3f281503f?w=600&auto=format' },
    { id: 2, brand: 'RAYBAN', title: 'Scholar Vision', price: '145', image: 'https://images.unsplash.com/photo-1591076482161-42ce6da69f67?w=600&auto=format' },
    { id: 3, brand: 'SILLOUETTE', title: 'Titanium Air', price: '299', image: 'https://images.unsplash.com/photo-1577803645773-f96470509666?w=600&auto=format' },
    { id: 4, brand: 'TOMMY HILFIGER', title: 'Classic Rim', price: '110', image: 'https://images.unsplash.com/photo-1574258495973-f010dfbb5371?w=600&auto=format' },
  ],
  shades: [
    { id: 5, brand: 'RAYBAN', title: 'Aviator Classic', price: '165', image: 'https://images.unsplash.com/photo-1511499767150-a48a237f0083?w=600&auto=format' },
    { id: 6, brand: 'OAKLEY', title: 'Holbrook XL', price: '198', image: 'https://images.unsplash.com/photo-1572635196237-14b3f281503f?w=600&auto=format' },
    { id: 7, brand: 'PRADA', title: 'Line Rossa', price: '245', image: 'https://images.unsplash.com/photo-1577803645773-f96470509666?w=600&auto=format' },
    { id: 8, brand: 'TOM FORD', title: 'Wayfarer Noir', price: '380', image: 'https://images.unsplash.com/photo-1614715838608-dd527c46231d?w=600&auto=format' },
  ],
  lens: [
    { id: 9, brand: 'ACUVUE', title: 'Oasys 1-Day', price: '45', image: lensesImage },
    { id: 10, brand: 'BAUSCH', title: 'Ultra Contact', price: '38', image: lensesImage },
    { id: 11, brand: 'AIR OPTIX', title: 'HydraGlyde', price: '52', image: lensesImage },
    { id: 12, brand: 'COOPER', title: 'Biofinity', price: '42', image: lensesImage },
  ],
};

const categories = [
  { id: 'glasses', name: 'Eye Glasses', image: glassesImage },
  { id: 'shades', name: 'Shades', image: shadesImage },
  { id: 'lens', name: 'Contact Lens', image: lensesImage },
];

const FeaturedCollection = () => {
  const [activeCategory, setActiveCategory] = useState('glasses');
  const activeProducts = productsData[activeCategory];

  return (
    <section className="bg-white py-16 sm:py-20 overflow-hidden">
      <div className="section-container">
        {/* Header Section */}
        <div data-aos="fade-up" className="mb-12 flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
          <h2 className="section-heading">
            Featured Collection
          </h2>
          <Link to="/shop" className="flex items-center gap-2 text-[14px] font-bold text-[#2A3182] transition-opacity hover:opacity-80 sm:text-[15px]">
            View Full Catalog
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="9 18 15 12 9 6"></polyline>
            </svg>
          </Link>
        </div>

        {/* Categories Section */}
        <div className="mb-14 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3 lg:gap-8">
          {categories.map((cat, index) => (
            <div
              key={cat.id}
              onClick={() => setActiveCategory(cat.id)}
              data-aos="fade-up"
              data-aos-delay={index * 100}
              className={`group relative flex h-[190px] cursor-pointer flex-col items-center overflow-hidden rounded-[30px] border-[1.5px] transition-all duration-300 sm:h-[200px]
                ${activeCategory === cat.id
                  ? 'border-[#2A3182] shadow-xl bg-[#f8faff]'
                  : 'border-gray-200 hover:border-gray-300 bg-white shadow-sm'}`}
            >
              <div className="flex h-[130px] w-full items-center justify-center overflow-hidden p-4 sm:h-[140px]">
                <img
                  src={cat.image}
                  alt={cat.name}
                  className="h-full w-full object-contain transition-transform duration-500 group-hover:scale-110"
                />
              </div>
              <div className="flex-1 flex items-center justify-center p-4">
                <span className="text-center text-[17px] font-bold tracking-tight text-gray-900 sm:text-[18px]">
                  {cat.name}
                </span>
              </div>
            </div>
          ))}
        </div>

        {/* Product Grid */}
        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4 lg:gap-8">
          {activeProducts.map((product, index) => (
            <div 
              key={product.id} 
              data-aos="fade-up"
              data-aos-delay={index * 100}
              className="group flex cursor-pointer flex-col rounded-[32px] border border-gray-100 bg-white p-3 transition-all duration-500 hover:shadow-2xl"
            >
              {/* Product Image Card */}
              <div className="relative mb-0 aspect-[4/4.5] overflow-hidden rounded-[28px] bg-[#f4f5f7]">
                {/* Price Badge */}
                <div className="absolute top-4 right-4 z-10">
                  <div className="bg-white px-3 py-1.5 rounded-full shadow-sm flex items-center gap-1">
                    <span className="text-[10px] font-bold text-[#2A3182] opacity-60 tracking-tighter uppercase">Ksh.</span>
                    <span className="text-[15px] font-black text-[#2A3182]">{product.price}</span>
                  </div>
                </div>

                <div className="w-full h-full">
                  <img
                    src={product.image}
                    alt={product.title}
                    className={`h-full w-full transition-transform duration-700 group-hover:scale-110 ${
                      activeCategory === 'lens' ? 'object-contain p-6' : 'object-cover'
                    }`}
                  />
                </div>
              </div>

              {/* Product Info */}
              <div className="p-5 pt-5 sm:p-6">
                <p className="text-[11px] font-bold text-gray-400 tracking-[0.1em] uppercase mb-1.5">
                  {product.brand}
                </p>
                <h3 className="text-[18px] font-bold leading-tight text-[#1a1a1a] transition-colors group-hover:text-[#2A3182] sm:text-[20px]">
                  {product.title}
                </h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturedCollection;
